export default function initPagination() {
    const containers = document.querySelectorAll('[data-container-products]');
    containers?.forEach(container => {

        const productsPerPage = parseInt(container.getAttribute('data-product-per-page'));
        const products = container.querySelectorAll('.card-product');
        const activePaginationClass = 'pagination--active'

        if (products.length > 0) {
            const totalPages = Math.ceil(products.length / productsPerPage);

            const pagination = container.querySelector('.pagination');
            if(pagination) {
                while (pagination.firstChild) {
                    pagination.removeChild(pagination.firstChild);
                }
                for (let i = 1; i <= totalPages; i++) {
                    const pageLink = document.createElement('span');
                    pageLink.textContent = i;
                    pagination.appendChild(pageLink);
                    pageLink.addEventListener('click', function () {
                        container.querySelectorAll(`.${activePaginationClass}`).forEach(activeEl => activeEl.classList.remove(activePaginationClass))
                        pageLink.classList.add(activePaginationClass)
                        showPage(i, products);
                        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    });
                }
            }

            function showPage(pageNumber, products) {
                products?.forEach(function (product, index) {
                    const startIndex = (pageNumber - 1) * productsPerPage;
                    const endIndex = startIndex + productsPerPage - 1;
                    const hideProductClass = 'card-product--hidden'

                    if (index >= startIndex && index <= endIndex) {
                        product.classList.remove(hideProductClass);
                    } else {
                        product.classList.add(hideProductClass);
                    }
                });
            }

            showPage(1, products);
        }

    })
}